import { IInteractionsNormalizer } from '../api/repositories/interactions/interactions.normalizer';
import { ActionsUnion, createAction } from '../helpers';

export enum EFavoritesActionType {
  // Post
  POST_FAVORITE = 'FAVORITES/POST',
  POST_FAVORITE_SUCCESS = 'FAVORITES/POST_SUCCESS',
  POST_FAVORITE_ERROR = 'FAVORITES/POST_ERROR',
  INCREMENT_FAVORITES = 'INCREMENT_FAVORITES',
  // Received
  GET_RECEIVED_FAVORITES = 'FAVORITES/RECEIVED/GET',
  GET_RECEIVED_FAVORITES_SUCCESS = 'FAVORITES/RECEIVED/GET_SUCCESS',
  RESET_RECEIVED_FAVORITES = 'FAVORITES/RECEIVED/RESET',
  // Sent
  GET_SENT_FAVORITES = 'FAVORITES/SENT/GET',
  GET_SENT_FAVORITES_SUCCESS = 'FAVORITES/SENT/GET_SUCCESS',
  RESET_SENT_FAVORITES = 'FAVORITES/SENT/RESET',
}

export interface IFavoritePayload {
  accountId: string;
  ratingStatus: string;
  ratingFeature: string;
  eventOrigin: string;
  refreshList?: boolean;
  resolve?: () => void;
}

export const favoritesActions = {
  // Post
  postFavorite: (payload: IFavoritePayload) =>
    createAction(EFavoritesActionType.POST_FAVORITE, payload),
  postFavoriteSuccess: (payload: IFavoritePayload) =>
    createAction(EFavoritesActionType.POST_FAVORITE_SUCCESS, payload),
  postFavoriteError: (payload: IFavoritePayload) =>
    createAction(EFavoritesActionType.POST_FAVORITE_ERROR, payload),
  incrementFavorites: () =>
    createAction(EFavoritesActionType.INCREMENT_FAVORITES),
  // Received
  getReceivedFavorites: (reset: boolean) =>
    createAction(EFavoritesActionType.GET_RECEIVED_FAVORITES, { reset }),
  getReceivedFavoritesSuccess: (
    interactions: IInteractionsNormalizer,
    isSub: boolean
  ) =>
    createAction(EFavoritesActionType.GET_RECEIVED_FAVORITES_SUCCESS, {
      ...interactions,
      isSub,
    }),
  resetReceivedFavorites: () =>
    createAction(EFavoritesActionType.RESET_RECEIVED_FAVORITES),
  // Sent
  getSentFavorites: (reset: boolean) =>
    createAction(EFavoritesActionType.GET_SENT_FAVORITES, { reset }),
  getSentFavoritesSuccess: (interactions: IInteractionsNormalizer) =>
    createAction(EFavoritesActionType.GET_SENT_FAVORITES_SUCCESS, interactions),
  resetSentFavorites: () =>
    createAction(EFavoritesActionType.RESET_SENT_FAVORITES),
};

export type IFavoritesAction = ActionsUnion<typeof favoritesActions>;
